import { StyleSheet, Platform, type ViewStyle } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export const BRAND_COLOR_PALETTE_THUMB_SIZE = 18

export function getBrandColorPaletteStyles(theme: Theme) {
  return StyleSheet.create({
    block: {
      marginBottom: theme.spacing.lg,
    },
    label: {
      fontSize: 14,
      color: theme.gray[600],
      marginBottom: theme.spacing.sm,
    },
    panel: {
      height: 160,
      borderRadius: 8,
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: theme.gray[300],
      ...(Platform.OS === 'web' && {
        cursor: 'crosshair' as never,
      }),
    },
    panelLayers: {
      ...StyleSheet.absoluteFillObject,
    },
    hueStrip: {
      height: 28,
      marginTop: theme.spacing.md,
      borderRadius: 8,
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: theme.gray[300],
      ...(Platform.OS === 'web' && {
        cursor: 'pointer' as never,
      }),
    },
    hueStripLayers: {
      flex: 1,
    },
    thumbHue: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      width: BRAND_COLOR_PALETTE_THUMB_SIZE,
      marginLeft: -BRAND_COLOR_PALETTE_THUMB_SIZE / 2,
      borderRadius: 4,
      borderWidth: 2,
      borderColor: theme.white,
      backgroundColor: 'transparent',
      pointerEvents: 'none',
    },
  })
}

export function getSaturationValueThumbStyle(
  theme: Theme,
  s: number,
  v: number
): ViewStyle {
  const t = BRAND_COLOR_PALETTE_THUMB_SIZE
  return {
    position: 'absolute',
    left: `${s * 100}%` as never,
    top: `${(1 - v) * 100}%` as never,
    width: t,
    height: t,
    borderRadius: t / 2,
    marginLeft: -t / 2,
    marginTop: -t / 2,
    borderWidth: 2,
    borderColor: theme.white,
    backgroundColor: 'transparent',
    pointerEvents: 'none',
  }
}

export function getHueThumbOffsetStyle(h: number): ViewStyle {
  const t = (h % 360) / 360
  return {
    left: `${t * 100}%` as never,
  }
}
